<template>
    <div class="articleinfo">
        <el-row>
            <el-col :span="24">
                <el-button style="padding: 0; margin: 20px;" type="text" icon="el-icon-back" @click="$router.go(-1)">
                    返回
                </el-button>
            </el-col>
        </el-row>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="文章类型" prop="type" >
                <el-radio-group v-model="ruleForm.type">
                    <el-radio :label="3" :disabled ="isdiable">图文</el-radio>
                    <el-radio :label="2" :disabled ="isdiable">视频</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="文章标题" prop="title">
                <el-input v-model="ruleForm.title"></el-input>
            </el-form-item>
            <el-form-item label="文章排序">
                <el-input v-model="ruleForm.sort"></el-input>
            </el-form-item>
            <el-form-item label="文章内容" :class="[ruleForm.type == 3?'is-required':'']" v-if="ruleForm.type == 3">
                <el-col :span="24">
                    <tinymce v-model="ruleForm.content" style="width: 90%"></tinymce>
                </el-col>
            </el-form-item>
            <el-form-item label="文章内容"  v-else>
                <el-input v-model="ruleForm.content" maxlength="200"></el-input>
            </el-form-item>
            <el-form-item label="视频链接" prop="media_source_url" v-if="ruleForm.type == 2">
                <el-input v-model="ruleForm.media_source_url" @blur="getVideoDuration"></el-input> 填入oss地址
            </el-form-item>
            <el-form-item label="视频封面" prop="cover_url" class="is-required" v-if="ruleForm.type == 2">
                <el-col :span="10">
                    <activityCustomUpload :tip="'温馨提示：建议宽度为338px；大小限制在200K之内'" :formName="'cover_url'" :formValue="ruleForm.cover_url"
                                          @uploadSuccess="uploadSuccess" >
                    </activityCustomUpload>
                </el-col>
            </el-form-item>
            <el-form-item label="文件" class="is-required" v-if="ruleForm.type == 3" >
                <el-col :span="4" v-for="i in ruleForm.text_image" :key="i.id">
                    <certificateupload :tip="''" :formName="i.title" :formValue="i.img_url" :id="i.id"
                                          @uploadSuccess="uploadSuccess2"  :num="ruleForm.text_image.length" @deleteList="deleteList">
                    </certificateupload>
                </el-col>
                <el-button size="mini" @click="addcerlist" v-if="isbtnshow">添加图片</el-button>
            </el-form-item>
            <div style="margin-left: 100px; margin-bottom: 50px;" v-if="this.ruleForm.type == 3">温馨提示：建议宽度为338px；大小限制在200K之内，最多上传6张</div>
            <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')" style="width: 100px;">确定</el-button>
                <el-button @click="resetForm('ruleForm')" style="width: 100px;">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import activityCustomUpload from "@/components/activityCustomUpload.vue";
import tinymce from "@/components/tinymce.vue";
import certificateupload from "@/components/commercialupload.vue";
import { articlesttusupdate, courseinfo } from "@/api/commerciam";
export default {
    name: "",
    data() {
      return {
            ruleForm: {
                title: "",
                type: 3,
                content: "",
                cover_url: "",
                sort: "",
                media_source_url: "",
                duration: "",
                id: "",
                category_id: "",
                text_image:[],
                
            },
            isbtnshow:true,
            istype:1,
            isdiable:false,
            arrayLength:0,
            rules: {
                title: [
                    {
                        required: true,
                        message: "请输入文章标题",
                        trigger: "blur",
                    },
                    {
                        min: 1,
                        max: 50,
                        message: "长度在 1 到 50 个字符",
                        trigger: "blur",
                    },
                ],
                type: [
                    {
                        required: true,
                        message: "请选择课程类型",
                        trigger: "change",
                    },
                ],
                cover_url: [
                    {
                        required: true,
                        message: "请上传视频封面",
                        trigger: "change",
                    },
                ],
                media_source_url: [
                    {
                        required: true,
                        message: "请输入视频链接",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    created(){
        this.ruleForm.id = this.$route.query.id;
        if (this.ruleForm.id) {
            this.getcourseinfo();
            
        } else {
            this.ruleForm.category_id = this.$route.query.category_id;
            this.isdiable = false
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.$watch("ruleForm.text_image", (newvalue) => {
                this.arrayLength = this.ruleForm.text_image.length;
                if (this.ruleForm.text_image.length >= 6) {
                    this.isbtnshow = false;
                } else {
                    this.isbtnshow = true;
                }
                console.log(this.isbtnshow,this.arrayLength,'this.arrayLength');
                this.ruleForm.is_released ==1 ?this.isdiable =true : this.isdiable = false
                console.log(this.isdiable,'this.isdiable2');
            });
        });
    },
    components: {
        activityCustomUpload,
        tinymce,
        certificateupload
    },
    methods: {
        getcourseinfo() {
            // 获取单个课程数据
            courseinfo({ id: this.ruleForm.id }).then((res) => {
                if (res.code == 1) {
                    this.ruleForm = res.data;
                    console.log(this.type);
                    // if(this.ruleForm.type == 3){
                    //     this.ruleForm.article_url = res.data.text_image[0]
                    // }
                    this.ruleForm.category_id = this.$route.query.category_id;
                    
                    this.getVideoDuration();
                }
            });
        },
        checkImgAttributes(arr) {
            return arr.every(obj => {
                // 检查 img 属性是否为空字符串或 null
                return obj.img_url == "" || obj.img_url == null;
            });
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                console.log(this.ruleForm,'ruleForm');
                if(valid){
                    if(this.ruleForm.type == 3){
                    let options = {
                        id:this.ruleForm.id,
                        title:this.ruleForm.title,
                        // cover_url:this.ruleForm.cover_url,
                        // media_source_url:this.ruleForm.media_source_url,
                        content:this.ruleForm.content,
                        sort:this.ruleForm.sort,
                        type:this.ruleForm.type,
                        category_id:this.ruleForm.category_id,
                        text_image:this.ruleForm.text_image,
                    }
                    if(this.ruleForm.content == ''){
                        this.$message({
                                message: "请填写文章内容!",
                                type: "error",
                            });
                            return
                    }
                    console.log(this.checkImgAttributes(this.ruleForm.text_image),this.ruleForm.text_image,'this.checkImgAttributes(this.ruleForm.text_image)');
                    
                    if(this.checkImgAttributes(this.ruleForm.text_image)){
                        this.$message({
                                message: "请上传文章封面!",
                                type: "error",
                            });
                            return
                    }
                    articlesttusupdate(options).then((res)=>{
                        if(res.code){
                            this.$message({
                                message: "保存成功!",
                                type: "success",
                            });
                            this.$router.go(-1)
                        }
                    })
                }else if(this.ruleForm.type == 2){
                    let options = {
                        id:this.ruleForm.id,
                        title:this.ruleForm.title,
                        cover_url:this.ruleForm.cover_url,
                        media_source_url:this.ruleForm.media_source_url,
                        content:this.ruleForm.content,
                        sort:this.ruleForm.sort,
                        type:this.ruleForm.type,
                        category_id:this.ruleForm.category_id,
                        duration:this.ruleForm.duration
                        // text_image:imgbox,
                    }
                    articlesttusupdate(options).then((res)=>{
                        if(res.code){
                            this.$message({
                                message: "保存成功!",
                                type: "success",
                            });
                            this.$router.go(-1)
                        }
                    })
                }else {
                    this.$message({
                        message: "填写完成后才可保存!",
                        type: "error",
                    });
                    return false;
                }
                } 
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$router.go(-1);
        },
        uploadSuccess(value) {
            const fileExtension = value.fileUrl.split(".").pop().toLowerCase();
            console.log(value);
            
            // 判断是否是图片格式
            const isImageFormat = ["png", "jpeg", "jpg", "gif", ""].includes(
                fileExtension
            );

            if (value.type != "delete") {
                if (!isImageFormat) {
                    this.$message({
                        message: "请上传图片格式文件（png, jpeg, jpg, gif）",
                        type: "error",
                    });
                    console.log("1");
                    return;
                }

                // 创建一个图片对象来获取图片尺寸
                const img = new Image();
                img.onload = () => {
                    // 检查图片尺寸是否符合要求
                    if (img.width > 9938) {
                        this.$message({
                            message: "图片尺寸不符，请重新上传",
                            type: "error",
                        });
                        console.log("2");
                        return;
                    }
                    // const maxSizeInBytes = 200 * 1024; // 200KB
                    // if (value.file.file.size > maxSizeInBytes) {
                    //     this.$message({
                    //         message: "图片大小不符，请重新上传",
                    //         type: "error",
                    //     });
                    //     console.log("3");
                    //     return;
                    // }
                    console.log(img.src, " img.src = value.fileUrl;");
                    // 图片格式、尺寸、大小均符合要求，更新表单数据
                    this.ruleForm[value.formName] = this.rules[value.formName] =
                        value.fileUrl;
                    this.$refs.ruleForm.validateField(value.formName);                    
                };
                // 加载图片以获取其尺寸
                img.src = value.fileUrl;
            } else {
                if (isImageFormat) {
                    console.log('是图片格式');
                    this.ruleForm[value.formName] = this.rules[value.formName] = value.fileUrl;
                    this.$refs.ruleForm.validateField(value.formName);
                    console.log(this.ruleForm,this.ruleForm[value.formName],'++++++++');
                    
                } else {
                    this.$message({
                        message: "请上传图片格式文件",
                        type: "error",
                    });
                    return;
                }
            }
        },
        uploadSuccess2(value) {
            console.log(this.ruleForm.text_image, value, '[[[[[]]]]]');
            const foundObject = this.ruleForm.text_image.find(
                (obj) => obj.id === value.id
            );
            console.log(foundObject,'foundObject');
            
            // console.log(foundObject);
            const fileExtension = value.fileUrl.split(".").pop().toLowerCase();

            // 判断是否是图片格式
            const isImageFormat = ["png", "jpeg", "jpg", "gif", ""].includes(
                fileExtension
            );

            if (isImageFormat) {
                console.log("是图片格式");
                foundObject.img_url = value.fileUrl;
            } else {
                this.$message({
                    message: "请上传图片格式文件",
                    type: "error",
                });
                return;
            }
        },
        getVideoDuration() {
            // 获取视频时长的函数
            // 创建一个 video 元素
            var video = document.createElement("video");
            // 设置 video 的 src 属性为输入框中的链接
            video.src = this.ruleForm.media_source_url;

            // 等待视频元数据加载完成后
            video.addEventListener("loadedmetadata", () => {
                // 获取视频的时长（秒）
                var duration = video.duration;
                console.log("视频时长（秒）：", duration);
                this.ruleForm.duration = duration + "";
                // 可以将时长格式化成更友好的时间格式，例如：hh:mm:ss
                // var formattedTime = this.formatTime(duration);
                // console.log("格式化后的时长：", formattedTime);
            });

            // 加载视频元数据
            video.load();
        },
        formatTime(seconds) {
            var hours = Math.floor(seconds / 3600);
            var minutes = Math.floor((seconds % 3600) / 60);
            var remainingSeconds = Math.floor(seconds % 60);

            var formatted = `${hours}:${minutes < 10 ? "0" : ""}${minutes}:${
                remainingSeconds < 10 ? "0" : ""
            }${remainingSeconds}`;
            return formatted;
        },
        addcerlist() {
            // 添加资格证书
            const obj = {
                id: Math.random(),
                img_url:'',
                title:'cover_url'+this.ruleForm.text_image.length,
            }
            if (this.arrayLength > 6) {
                this.isbtnshow = false;
                return;
            } else {
                this.ruleForm.text_image.push(obj);
                console.log(this.ruleForm);
                
            }
        },
        deleteList(value) {
            console.log(value, "----------------");
            const indexToDelete = this.ruleForm.text_image.findIndex(
                (obj) => obj.id === value.id
            );

            // 如果找到了匹配的对象
            if (indexToDelete != -1) {
                // 从数组中删除该对象
                this.ruleForm.text_image.splice(indexToDelete, 1);
                this.isbtnshow = true;
            }
        },
    },
};
</script>

<style>
.articleinfo .el-input {
    width: 300px;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
}
.avatar {
    width: 100px;
    height: 100px;
    display: block;
}
</style>
